var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"industryBar"},[_c('div',{ref:"bar",staticClass:"bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }